import StateProvider from "./src/StateProvider"
export const wrapRootElement = StateProvider
